// Generated by ReScript, PLEASE EDIT WITH CARE


function toString(blacklistType) {
  switch (blacklistType) {
    case /* Documents */0 :
        return "DOCUMENTS";
    case /* Device */1 :
        return "DEVICE";
    case /* Face */2 :
        return "FACE";
    
  }
}

function toDisplayString(blacklistType) {
  switch (blacklistType) {
    case /* Documents */0 :
        return "Documents (Aadhaar, DL)";
    case /* Device */1 :
        return "Device";
    case /* Face */2 :
        return "Face (Biometric)";
    
  }
}

function fromString(value) {
  switch (value) {
    case "DEVICE" :
        return /* Device */1;
    case "DOCUMENTS" :
        return /* Documents */0;
    case "BIOMETRIC" :
    case "FACE" :
        return /* Face */2;
    default:
      return ;
  }
}

function isSupported(blacklistType) {
  return true;
}

function toApiValue(blacklistType) {
  switch (blacklistType) {
    case /* Documents */0 :
        return "document";
    case /* Device */1 :
        return "device";
    case /* Face */2 :
        return "face";
    
  }
}

var allBlacklistTypes = [
  /* Documents */0,
  /* Device */1,
  /* Face */2
];

var supportedBlacklistTypes = [
  /* Documents */0,
  /* Device */1,
  /* Face */2
];

export {
  toString ,
  toDisplayString ,
  fromString ,
  isSupported ,
  toApiValue ,
  allBlacklistTypes ,
  supportedBlacklistTypes ,
  
}
/* No side effect */
